module.exports = __webpack_public_path__ + "img/slider_19.a578cc9a.jpg";